import { useEffect, useRef, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { canViewDriverDirectory, getDirectoryBusinessOptions } from '../../services/DriverDirectory';

// Component-local storage deliberately avoids retaining authorization choices in
// a shared query cache. Generation checks reject late refresh/account responses.
export const useDirectoryBusinessOptions = () => {
  const user = useSelector((state) => state.user.user);
  const owner = user?.id;
  const allowed = owner != null && canViewDriverDirectory(user);
  const generation = useRef(0);
  const [state, setState] = useState({ status: 'loading', revision: 0 });
  const reload = useCallback(async () => {
    const revision = ++generation.current;
    setState({ owner, status: 'loading', revision });
    if (!allowed) return;
    try {
      const data = await getDirectoryBusinessOptions();
      if (generation.current === revision) setState({ owner, status: 'success', data, revision });
    } catch (error) {
      if (generation.current === revision) setState({ owner, status: 'error', error, revision });
    }
  }, [owner, allowed]);
  useEffect(() => {
    reload();
    return () => { generation.current += 1; };
  }, [reload]);
  return {
    ...(allowed && state.owner === owner ? state : { status: 'loading', revision: -1 }),
    reload,
  };
};
